<template>
  <DefaultLayoutPublico>
    <Header />
    <ListProducts ref="listProductsRef" :namePage="'home'"/>
  </DefaultLayoutPublico>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router'
import DefaultLayoutPublico from '@/layouts/DefaultLayoutPublico.vue'
import Header from '../components/Header.vue'
import ListProducts from '../components/ListProducts.vue'

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

</style>
